enum ACTION_STRINGS {
    SET_PRE_SURVEY = "[PRE SURVEY] SET",
    REPLACE_PRE_SURVEY = "[PRE SURVEY] REPLACE",
    ADD_PRE_SURVEY = "[PRE SURVEY] ADD",

    RESET_ERROR = "[PRE SURVEY] RESET ERROR",
}

export default ACTION_STRINGS;